import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { blogIndexHead } from "@/lib/route-seo";

export const Route = createFileRoute("/blog/")({
  head: () => blogIndexHead(),
  component: Blog,
});
